module.exports = __webpack_public_path__ + "assets/img/a1.5f117d4d.png";